<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-align: center;">I want to acknowledge Professor Awasom, Ben Williams, John Dale, Zeb Townsel, Henry Williams, Danita, Daniele, and numerous others who helped inspire the storyline of this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?ffb5a45c